import { render, staticRenderFns } from "./CardNewsHome.vue?vue&type=template&id=d62ffcbc&scoped=true&"
import script from "./CardNewsHome.vue?vue&type=script&lang=js&"
export * from "./CardNewsHome.vue?vue&type=script&lang=js&"
import style0 from "./CardNewsHome.vue?vue&type=style&index=0&id=d62ffcbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d62ffcbc",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VHover } from 'vuetify/lib/components/VHover';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCardTitle,VCol,VHover})
